export const getState = () => ({
	medicamentos: {}, // A chave é o id do medicamento
	medicamento: null,
	loading_medicamento: false,
	loading_medicamentos: false,
	medicamentos_lidos: {}
});
